export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-latin-400-normal.woff2?9698cc7dbf147ed363b617fc4d467769";